// getters

const form = state => state.form

export default {
  form
}



// WEBPACK FOOTER //
// ./src/store/modules/base/form/getters.js